import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import AboutMain from "../images/about/about-main.jpg";
import LogoWirasana from "../images/logo/logo.png";
import PlanTrip from "../components/home/Plantrip";
import Navbar2 from "../components/Navbar2";
import React from "react";

function About() {
  const { t } = useTranslation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <section className="about-page">
        <Navbar2 />
        <HeroPages name={t("about")} />

        <div className="container">
          {/* <div className="about-main">
            <img className="about-main__img" src={AboutMain} alt="car-renting" />

            <div className="about-main__text">
              <h3>{t("about_company")}</h3>
              <h2>{t("about_headline")}</h2>
              <p>{t("about_description")}</p>
            </div>
          </div> */}

          <div className="about-company-section">
            <img src={LogoWirasana} alt="Wirasana Rent A Car Logo" className="about-company-section__logo" />

            <h2 className="about-company-section__title">{t("your_trusted_mobility")}</h2>

            <p className="about-company-section__description">
              {t("wirasana_is_professional")}
              <br />
              <br />
              {t("our_mission_is_to_make")}
            </p>
          </div>

          <PlanTrip />
        </div>
      </section>

      <Footer />
    </>
  );
}

export default About;
